import React from 'react'
import "./App.css"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './pages/Home'
import CoursePlayer from './pages/Student/CoursePlayer';
import LeaderBoard from './pages/Student/LeaderBoard';
import StudentRegistration from './pages/Student/StudentRegistration';
import NoMatch from './pages/NoMatch';
import Assignment from './pages/Dashboard/Assignment';
import AssignmentMark from './pages/Dashboard/AssignmentMark';
import Dashboard from './pages/Dashboard/Dashboard';
import Quizzes from './pages/Dashboard/Quizzes';
import Videos from './pages/Dashboard/Videos';
import useAuthCheck from './hooks/useAuthCheck';
import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';
import { useSelector } from 'react-redux';
import EditQuiz from './pages/Dashboard/EditQuiz';
import AddQuiz from './pages/Dashboard/AddQuiz';
import Loader from './components/ui/Loader';
import AdminPublicRoute from './components/AdminPublicRoute';
import Login from './pages/Login';


export default function App() {
  const authChecked = useAuthCheck();
  const { user } = useSelector(state => state.auth)

  return (
    !authChecked ? <Loader /> :
      <BrowserRouter>
        {
          <Routes>
            {user?.role === "admin" ?
              <>
                <Route path='/admin/assignment' element={<PrivateRoute><Assignment /></PrivateRoute>} />
                <Route path='/admin/assignment-mark' element={<PrivateRoute><AssignmentMark /></PrivateRoute>} />
                <Route path='/admin/dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path='/admin/quizzes' element={<PrivateRoute><Quizzes /></PrivateRoute>} />
                <Route path='/admin/add-quiz' element={<PrivateRoute><AddQuiz /></PrivateRoute>} />
                <Route path='/admin/videos' element={<PrivateRoute><Videos /></PrivateRoute>} />
                <Route path='/admin/edit-quiz/:quizId/:videoId' element={<EditQuiz />} />
              </> :
              <>
                <Route path='/home' element={<PrivateRoute><Home /></PrivateRoute>} />
                <Route path='/course-player/:videoId' element={<PrivateRoute><CoursePlayer /></PrivateRoute>} />
                <Route path='/course-player/' element={<PrivateRoute><CoursePlayer /></PrivateRoute>} />
                <Route path='/leaderboard' element={<PrivateRoute><LeaderBoard /></PrivateRoute>} />
                <Route path='/student-registration' element={<StudentRegistration />} />
              </>
            }

            <Route index element={<PublicRoute><Login role="Student" /></PublicRoute>} />
            <Route path='/admin/admin-login' element={<AdminPublicRoute><Login role="Admin" /></AdminPublicRoute>} />
            <Route path='*' element={<NoMatch />} />
          </Routes>
        }
      </BrowserRouter>
  )
}
